// extracted by mini-css-extract-plugin
module.exports = {"doc-position-1501-max":"doc-position-1501-max___2W9eg","docPosition1501Max":"doc-position-1501-max___2W9eg"};